import { useQuery } from '@tanstack/react-query';
import { api, IssueLedger } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export const useGlobalStats = () => {
  const { user, currentOrganization } = useAuth();

  return useQuery<IssueLedger>({
    queryKey: ['globalStats', currentOrganization?.id],
    queryFn: () => api.getGlobalStats(),
    enabled: !!user && !!currentOrganization,
    staleTime: 30 * 1000,
  });
};
